import CVSchema from 'schemas/cv.schema'
import { EmploymentHistorySchema } from 'schemas/history'
import { EducationHistoryOptionalSchema } from 'schemas/history/educationHistory.schema'
import { LanguageLevelSchema } from 'schemas/language.schema'
import { ListIndustrySchema } from 'schemas/listItem.schema'
import { z } from 'zod'

import skillValidator from './skill.validator'

export const cvValidator = CVSchema.superRefine((cv, ctx) => {
  if (cv.employmentHistory.length === 0) {
    ctx.addIssue({
      path: ['employmentHistory'],
      code: z.ZodIssueCode.custom,
      message: 'custom.atLeast1EducationOrExperience'
    })
  }
})

export const cvParseValidator = CVSchema.extend({
  employmentHistory: EmploymentHistorySchema.extend({
    skills: skillValidator.array()
  }).array(),
  educationHistory: EducationHistoryOptionalSchema.array(),
  industries: ListIndustrySchema.array(),
  expectedSalaryEuros: z.number().min(0),
  dateOfBirth: z.string().optional().nullable(),
  contactInformation: z.string(),
  languages: LanguageLevelSchema.array()
})

export type ICV = z.infer<typeof cvValidator>
export type IParseCV = z.infer<typeof cvParseValidator>
